import { BabylonState } from "../state";

export function onSetTime(state: BabylonState, time: bigint) {
  state.sceneConfig.time = time;
}
